<template>

  <v-container class="table-container pa-0" fluid>

    <v-row v-if="!!$slots['full-search']"
              class="searchline"
              no-gutters>
      <!--- full text search ----------------------------------------------------------------------------->
      <slot name="full-search" />

      <!--- show/hide detail filters ------------------------------------------------------------------------->
      <template v-if="!hideDetailsSearch">
        <v-btn slot="activator"
               text
               color="primary"
               class="details--btn ma-0 ml-6 text"
               @click="toggleFilters">{{ detailSearchButtonText }}
        </v-btn>
      </template>

    </v-row>

    <!--- detail filters ----------------------------------------------------------------------------->
    <div v-if="showFilters"
         class="filters-slot">
      <slot name="detail-filters" />
    </div>

    <!--- excel export ------------------------------------------------------------------------->
    <div v-if="!noExcelDownload"
         :class="hideDetailsSearch || !showFilters ? 'no-search-excel' : ''"
         class="export--button">
      <v-btn color="primary"
             @click="$emit('excel')">
        <v-icon>file_download</v-icon>
        EXCEL
      </v-btn>
    </div>

    <!--- data table ----------------------------------------------------------------------------->
    <slot />

  </v-container>

</template>
<script>
import {RIGHTS} from "@/store/user";

export default {
  name: "TableContainer",
  props: {
    hideDetailsSearch: {
      type: Boolean,
      default: false
    },
    noExcelDownload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showFilters: false
    };
  },
  computed: {
    detailSearchButtonText() {
      return this.showFilters ? "Detailsuche schließen" : "Detailsuche";
    }
  },
  mounted () {
    if (!this.$store.getters.checkAuthorization(RIGHTS.EXCEL)) this.noExcelDownload = true;
  },
  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters;
      if (!this.showFilters) {
        //reset filter input fields
        this.$emit('reset-filters');
      }
    }
  }
};
</script>
<style>
.table-container tr {
  cursor: pointer;
}

.table-container th {
  position: relative;
}

.table-container .filters-slot {
  margin-top: 40px;
}

.table-container td .tooltip--top span *:first-child {
  margin-top: -4px;
  padding-top: 4px;
}

.table-container td {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.table-container td.text--align--center {
  text-align: center;
}

.table-container td.single--line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}

.table-container .data--table {
  margin-top: 40px;
}

.table-container .searchline {
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.table-container .detail--filters {
  margin: 0 0 16px 0;
}

.table--actions .v-icon {
  margin-right: 8px;
}

.table-container table.table tbody td:first-child,
.table-container table.table tbody td:not(:first-child),
.table-container table.table thead td:first-child,
.table-container table.table thead td:not(:first-child) {
  padding: 0 16px !important;
}

.table-container table.table tbody th:first-child,
.table-container table.table tbody th:not(:first-child),
.table-container table.table thead th:first-child,
.table-container table.table thead th:not(:first-child) {
  padding: 0 0 0 16px !important;
}

.table-container th .v-icon {
  position: absolute;
  left: 0;
}

.table-container .export--button {
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;
}

.table-container .export--button.no-search-excel {
  margin-top: -56px !important;
}

.table-container .export--button .v-btn {
  margin: 0;
}
</style>
